import React from 'react';
import ReactDOM from 'react-dom/client';
import AuthGate from './AuthGate';
import PasswordRecoveryGate from './PasswordRecoveryGate';
import PlatformRouterV2 from './PlatformRouterV2';
import PlatformSupportPanel from './PlatformSupportPanel';
import GlobalMinaAssistant from './GlobalMinaAssistant';
import BamsNfcBridge from './BamsNfcBridge';
import './styles.css';
import './auth.css';
import './platform.css';
import './operations.css';
import './templates.css';
import './client-ui-cleanup.css';
import './portofino-theme.css';
import './bams-nfc.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PasswordRecoveryGate>
      <AuthGate>
        <PlatformRouterV2 />
        <GlobalMinaAssistant />
        <PlatformSupportPanel />
        <BamsNfcBridge />
      </AuthGate>
    </PasswordRecoveryGate>
  </React.StrictMode>,
);
